import { style } from "typestyle";

export const listEditorContainerCN = () =>
  style({
    display: "flex",
    flexDirection: "column",
    marginBottom: "8px",
    margin: "0 auto",
    marginRight: "0",
    $nest: {
      "&:first-child": {
        marginLeft: "0",
      },
    },
  });

export const labelListEditorContainerCN = () =>
  style({
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "30px",
    marginBottom: "24px",
    color: "rgba(0, 0, 0, 0.87)",
  });

export const wrapperEditableListCN = () =>
  style({
    marginTop: "16px",
    boxShadow:
      "0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12)",
    $nest: {
      "& > div:first-child > div": {
        borderTopRightRadius: "2px",
        borderTopLeftRadius: "2px",
      },
      "& > div:last-child > div": {
        borderBottomRightRadius: "2px",
        borderBottomLeftRadius: "2px",
        boxShadow: "none",
      },
    },
  });
